import classNames from 'classnames'
import React, { ReactElement, ReactNode } from 'react'
import { Text } from '../text/Text'
import styles from './index.module.css'
import { NativeModalBase } from './NativeModalBase'

export { ModalPortalContext, useModalPortalContainer } from './NativeModalBase'

export type ModalSize = 'small' | 'medium' | 'large' | 'xl'
export interface ModalProps {
  onClose: () => void
  open?: boolean
  className?: string
  title?: ReactNode
  'aria-title'?: string
  description?: ReactNode
  initialFocus?: React.MutableRefObject<HTMLButtonElement | null>
  modalBackgroundClassName?: string
  modalContainerClassName?: string
  modalContentClassName?: string
  children: ReactNode
  noPaddingBelowDescription?: boolean
  scrollable?: boolean
  icon?: ReactNode
  bottomPadding?: boolean
  size?: ModalSize
  rightContent?: ReactNode
  hideCloseButton?: boolean
}

export function ModalBase({ size = 'small', scrollable = false, ...props }: ModalProps): ReactElement {
  return <NativeModalBase size={size} scrollable={scrollable} {...props} />
}

export function ModalSmallContentSectionLayout(props: { className?: string; children: ReactNode; title?: string }) {
  return (
    <div className={classNames('flex flex-col gap-4 mb-6 last:mb-0', props.className)}>
      {props.title && (
        <Text as="p" textType="base" semiBold className="text-emphasis-high">
          {props.title}
        </Text>
      )}
      {props.children}
    </div>
  )
}

export function ModalBaseButtons(props: { className?: string; children: ReactNode }): ReactElement {
  return <div className={classNames(styles.buttons, props.className)}>{props.children}</div>
}
